import moment from "moment";

export const getDateDifference = (
  endDate,
  startDate,
  diffIn = "days",
  disableRound = false
) => {
  const _momentEndDate = moment(endDate ?? Date.now());
  const _momentStartDate = moment(startDate ?? Date.now());

  const _difference = !disableRound
    ? Math.round(_momentEndDate.diff(_momentStartDate, diffIn, true))
    : Math.ceil(_momentEndDate.diff(_momentStartDate, diffIn, true));

  return _difference;
};
